import { Component} from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

export interface Team {
  image: string;
  name: string;
  position: string;
}

@Component({
  standalone: false,
  selector: 'app-our-team',
  templateUrl: './our-team.component.html',
  styleUrl: './our-team.component.css'
})
export class OurTeamComponent {
  //Footer
  socialLinks = [
    { icon: 'bi-facebook', url: '/' },
    { icon: 'bi-twitter-x', url: '/' },
    { icon: 'bi-pinterest', url: '/' },
    { icon: 'bi-dribbble', url: '/' }
  ];

  quickLinks = [
    { name: 'About Us', url: '/about-us' },
    { name: 'Services', url: '/services' },
    { name: 'Portfolio', url: '/portfolio-one' },
    { name: 'Blogs', url: '/blog-grid' },
    { name: 'Contact Us', url: '/contact' }
  ];

  recentPosts = [
    {
      image: 'assets/images/blogs/post-img-sm.jpg',
      title: 'Ut venenatis, Commodo ligula',
      desc: 'Lorem ipsum dolor sit amet, adipiscing elit...'
    },
    {
      image: 'assets/images/blogs/post-img-sm-2.jpg',
      title: 'Ut venenatis, Commodo ligula',
      desc: 'Lorem ipsum dolor sit amet, adipiscing elit...'
    }
  ];
  
  // Team
  teamMembers: Team[] = [
    {
      image: 'assets/images/team/team-01.jpg',
      name: 'James Brewer',
      position: 'Digital Designer'
    },
    {
      image: 'assets/images/team/team-02.jpg',
      name: 'Mesha Albert',
      position: 'Senior User Interface'
    },
    {
      image: 'assets/images/team/team-03.jpg',
      name: 'Arthur Stewart',
      position: 'Founder & CEO'
    },
    {
      image: 'assets/images/team/team-04.jpg',
      name: 'Eden Charles',
      position: 'Art Director'
    }
  ];
}
